import React, { useEffect } from "react";
import "./css/Home.css"; // styling separate file me

export default function Home() {
  useEffect(() => {
    document.title = "Home | My MLM Website";
  }, []);

  return (
    <div className="home-container">
      <h1>Welcome to Our World Class MLM Marketing Platform 🚀</h1>
      <p>
        हमारी टीम आपको <b>MLM Marketing</b> में सफल बनाने के लिए high-quality{" "}
        <b>leads</b> provide करती है। Leads ही आपके business की growth की असली
        ताकत हैं।
      </p>

      <h2>हम क्या Offer करते हैं?</h2>
      <ul>
        <li>Verified Leads (जिन्होंने खुद interest show किया हो)</li>
        <li>Auto Lead Capture System (form भरते ही data save)</li>
        <li>Email & SMS Marketing Integration</li>
        <li>Direct Contact Numbers और Emails</li>
        <li>Leads Filtering by Age, Location & Interest</li>
      </ul>

      <h2>Leads से फायदा?</h2>
      <p>
        सही leads मिलने पर आपकी MLM Team तेजी से grow करती है। आपको बार-बार
        लोगों को समझाने की ज़रूरत नहीं पड़ेगी क्योंकि leads पहले से interested
        होंगी।
      </p>
      <p> This is done by surya sir </p>
      <div className="cta-box">
        <h3>👉 Free Consultation</h3>
        <p>
          आज ही हमसे जुड़ें और अपनी MLM Business के लिए Leads Generate करने का
          सही तरीका जानें।
        </p>
        <button className="cta-btn">Get Free Leads Info</button>
      </div>
    </div>
  );
}
